export var ie10Plus = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)';